module.exports = __webpack_public_path__ + "img/14.fda5076d.png";